import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, Observer, Subject, Subscription } from 'rxjs';
import { Event as NavigationEvent, NavigationStart, Router } from '@angular/router';
import { WindowRef } from '../../../shared/services/window.service';

// TODO find a better way to import these libs here
import SockJS = require('sockjs-client');
import Stomp = require('webstomp-client');

@Injectable()
export class FundperformanceService {
  public messages: Subject<Stomp.Message>;
  stompClient = null;
  subscriber = null;
  connection: Promise<any>;
  connectedPromise: any;
  listener: Observable<any>;
  listenerObserver: Observer<any>;
  alreadyConnectedOnce: boolean = false;
  private subscription: Subscription;

  constructor(
    @Inject(DOCUMENT) private document: any,
    public $window: WindowRef,
    public router: Router
  ) {
    this.messages = new Subject<Stomp.Message>();
    this.connection = this.createConnection();
    this.listener = this.createListener();
  }

  connect(sdate, edate, lan) {
    if (this.connection === null) {
      this.connection = this.createConnection();
    }

    // building absolute path so that websocket doesnt fail when deploying with a context path
    const loc = window.location;
    // const url = 'http://localhost:8090/fundPerformance'; // in case of local run
    let url = '//' + loc.host + loc.pathname + 'fundPerformance'; // in case of prod deployment

    const socket = new SockJS(url);
    this.stompClient = Stomp.over(socket);
    let headers = {};
    //headers['X-XSRF-TOKEN'] = this.csrfService.getCSRF('XSRF-TOKEN');
    this.stompClient.connect(headers, () => {
      this.connectedPromise('success');
      this.connectedPromise = null;
      if (sdate != null && edate != null && lan != null) {
        this.sendActivity(sdate, edate, lan);
      }
      if (!this.alreadyConnectedOnce) {
        this.router.events.forEach((event: NavigationEvent) => {
          if (event instanceof NavigationStart) {
            if (this.router.url === '/fund') {
              this.unsubscribe();
              this.disconnect();
            }

          }
        });
      }
      this.alreadyConnectedOnce = true;
    });

  }

  disconnect() {
    if (this.stompClient !== null) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
    this.connection = null;
  }

  receive() {
    return this.listener;
  }

  sendActivity(sdate, edate, lang) {
    if (this.stompClient !== null && this.stompClient.connected) {
      this.stompClient.send(
        '/topic/request/fundperformance', // destination
        JSON.stringify({
          startDate: sdate,
          endDate: edate,
          language: lang
        }), // body
        {} // header
      );
    }
  }

  subscribe() {
    this.connection.then(() => {
      this.subscriber = this.stompClient.subscribe('/user/queue/response/fundperformance', data => {
        this.listenerObserver.next(JSON.parse(data.body));
      });
    });
  }

  unsubscribe() {
    if (this.subscriber !== null) {
      this.subscriber.unsubscribe();
    }
    this.listener = this.createListener();
  }

  private createListener(): Observable<any> {
    return new Observable(observer => {
      this.listenerObserver = observer;
    });
  }

  private createConnection(): Promise<any> {
    return new Promise((resolve, reject) => this.connectedPromise = resolve);
  }
}
